import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import AllenKeyImage from "@coworker/app/src/assets/images/allen-key.png";
import styles from "./RotatingAllenKey.module.css";

export const RotatingAllenKey = () => {
  return <FixaImage src={AllenKeyImage} className={styles["image"]} />;
};
